import {
  isValidIcon,
  isValidTheme
} from '../propsValidator'

export const theme = {
  type: String,
  default: '',
  validator: (value) => value === '' || (!!value && isValidTheme(value)),
}

export const icon = {
  type: String,
  default: '',
  validator: (value) => value === '' || (!!value && isValidIcon(value)),
}
